/**
 * CONSULTINGPROTOCOL.JS | Micheals Infrastructure Advisory
 * COMPONENT: Forensic Data Framing & Strategic Stewardship
 * VERSION: 6.2.3
 */

import React from 'react';

const ConsultingProtocol = ({ children, title, description, financialImpact, icon: Icon, points }) => {
  return (
    <div className="technical-border p-12 bg-white border border-stone-200 transition-all duration-500 hover:border-amber-800">
      {/* Header Framework */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-4">
          {Icon && <Icon className="text-stone-900" size={20} />}
          <span className="tech-label">MED_STRATEGY_PROTOCOL</span>
        </div>
        <div className="h-px w-16 bg-stone-200"></div>
      </div>

      {/* Primary Content */}
      <div className="max-w-3xl mb-12">
        <h3 className="text-4xl font-serif italic text-stone-950 mb-6 tracking-tight">
          {title}
        </h3>
        <p className="text-stone-600 text-lg leading-relaxed font-light">
          {description}
        </p>
      </div>

      {/* Protocol Metrics */}
      {points && (
        <div className="grid md:grid-cols-3 gap-8 mb-12 border-t border-stone-100 pt-8">
          {points.map((pt, i) => (
            <div key={i}>
              <div className="text-[9px] font-black uppercase tracking-[0.2em] text-amber-800 mb-2">
                {pt.label}
              </div>
              <p className="text-stone-500 text-sm leading-relaxed">
                {pt.detail}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Forensic Impact Statement */}
      {financialImpact && (
        <div className="bg-stone-50 border-l-2 border-stone-900 p-6">
          <p className="text-stone-800 italic font-light text-sm">
            <span className="font-bold text-stone-950 not-italic uppercase tracking-widest text-[10px] mr-3">
              Forensic Impact:
            </span>
            {financialImpact}
          </p>
        </div>
      )}

      {/* Children for custom injection */}
      {children && <div className="mt-8">{children}</div>}
    </div>
  );
};

export default ConsultingProtocol;